import React, { useEffect } from 'react'

import financingBar from '../../assets/images/log-ai/barra-financiamento-prr.png'
import { LOG_AI_EN, LOG_AI_PT } from '../../constants/logAiContent'

const LogAiPage = ({ lang }) => {
  const copy = lang === 'en' ? LOG_AI_EN : LOG_AI_PT

  useEffect(() => {
    window.scrollTo(0, 0)
    const raf = window.requestAnimationFrame(() => window.scrollTo(0, 0))
    const t = window.setTimeout(() => window.scrollTo(0, 0), 350)
    return () => {
      window.cancelAnimationFrame(raf)
      window.clearTimeout(t)
    }
  }, [])

  return (
    <section id="log-ai" className="content container log-ai-page">
      <h1>{copy.title}</h1>
      <p className="log-ai-page__lead">{copy.lead}</p>

      <div className="log-ai-page__financing" aria-label={copy.financing.label}>
        <img src={financingBar} alt={copy.financing.alt} width={1040} height={150} />
        <p>{copy.financing.text}</p>
      </div>

      <h2 id="log-ai-identification">{copy.identification.title}</h2>
      <dl className="log-ai-page__data" aria-labelledby="log-ai-identification">
        {copy.identification.items.map(item => (
          <div key={item.label}>
            <dt>{item.label}</dt>
            <dd>
              {item.value.split('\n').map((line, i) => (
                <React.Fragment key={line}>
                  {i > 0 ? <br /> : null}
                  {line}
                </React.Fragment>
              ))}
            </dd>
          </div>
        ))}
      </dl>

      <h2>{copy.description.title}</h2>
      {copy.description.paragraphs.map(text => (
        <p key={text}>{text}</p>
      ))}

      <h2>{copy.objectives.title}</h2>
      <ul>
        {copy.objectives.items.map(item => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2 id="log-ai-workstreams">{copy.workstreams.title}</h2>
      <div className="log-ai-page__workstreams" aria-labelledby="log-ai-workstreams">
        {copy.workstreams.items.map(item => (
          <article key={item.title} className="log-ai-page__workstream">
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </article>
        ))}
      </div>

      <h2>{copy.results.title}</h2>
      <ul>
        {copy.results.items.map(item => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <p className="log-ai-page__support">
        {copy.supportNote}{' '}
        <a href={copy.supportHref} target="_blank" rel="noopener noreferrer">
          {copy.supportLinkLabel}
        </a>
        .
      </p>
      <p className="log-ai-page__disclaimer">{copy.disclaimer}</p>
    </section>
  )
}

export default LogAiPage
